import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  OnDestroy,
  PLATFORM_ID,
  signal,
  viewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromStore from '../../store';

import { StripEmbedPipe, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { DatePipe, isPlatformBrowser, JsonPipe, SlicePipe } from '@angular/common';
import { HeaderComponent } from 'src/app/standalone/components/header/header.component';
import { EventPracticalInfoComponent } from '../../components/event-practical-info/event-practical-info.component';
import { BreadcrumbsComponent } from 'src/app/standalone/components/breadcrumbs/breadcrumbs.component';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe, StripHtmlPipe, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { RouterLink } from '@angular/router';
import { LinkComponent } from '@teamfoster/sdk/button';
import { EventHeaderComponent } from '../../components/event-header/event-header.component';
import { EventMetadataComponent } from '../../components/event-metadata/event-metadata.component';
import { ContentBlockAgendaComponent } from 'src/app/content-blocks/components/content-block-agenda/content-block-agenda.component';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { IconComponent } from '@teamfoster/sdk/icon';
import { InViewportDirective } from '@teamfoster/sdk/in-view';

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./event-detail.component.scss'],
  imports: [
    EventHeaderComponent,
    EventPracticalInfoComponent,
    BreadcrumbsComponent,
    EventDatePipe,
    ResizeHtmlImagesPipe,
    StripEmbedPipe,
    FromDictionaryPipe,
    LinkComponent,
    EventMetadataComponent,
    LinkComponent,
    ContentBlockAgendaComponent,
    DynamicHooksModule,
    DatePipe,
    RouterLink,
    UrlRewritePipe,
    SlicePipe,
    IconComponent,
    InViewportDirective,
  ],
})
export class EventDetailComponent implements AfterViewInit, OnDestroy {
  private store = inject(Store);

  cookiePreferences$ = this.store.selectSignal(getCookiePreferences);

  event$ = this.store.selectSignal(fromStore.getSelectedEvent);
  relatedEvents$ = this.store.selectSignal(fromStore.getAllRelatedEvents);

  content = viewChild<ElementRef>('content');
  hideScrollIndicator = signal(false);
  headerLoaded = signal(false);

  platformId = inject(PLATFORM_ID);

  cd = inject(ChangeDetectorRef);

  private intersectionObserver?: IntersectionObserver;
  indicatorChecked = false;

  breadcrumbs = computed(() => {
    const event = this.event$();

    // console.log('Deps:', event?.departments);

    return [
      { text: 'Agenda', routerLink: ['/agenda'], url: '' },
      //{ label: event.parentEvent.title, routerLink: event.parentEvent.routerLink },
    ];
  });

  hasMoreDates = computed(() => {
    const dates = this.event$()?.eventDates;
    if (!dates) {
      return false;
    }
    return dates.length > 3;
  });

  showDateCount = signal(5);

  isShortText = computed(() => {
    const event = this.event$();
    const text = new StripHtmlPipe().transform(event?.text || '') || '';
    return text.length < 1000;
  });

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    //const content = this.content();

    //this.intersectionObserver = new IntersectionObserver(
    //  entries => {
    //    entries.forEach(entry => {
    //      // if user has scrolled at all
    //      if (window.scrollY > 1 && this.indicatorChecked) {
    //        this.intersectionObserver?.unobserve(entry.target);
    //        return;
    //      }

    //      this.indicatorChecked = true;
    //      const isOutOfView = entry.boundingClientRect.top + 200 > window.innerHeight;
    //      this.hideScrollIndicator.set(!isOutOfView);
    //    });
    //  },
    //  { threshold: 0.1 }
    //);

    //if (content) {
    //  this.intersectionObserver?.observe(content.nativeElement);
    //}
  }

  ngOnDestroy(): void {
    this.intersectionObserver?.disconnect();
  }

  scrollToContent() {
    const contentElement = this.content()?.nativeElement;

    if (!contentElement) {
      return;
    }
    const yOffset = 200 * -1; // Your offset value
    const yPosition = contentElement.getBoundingClientRect().top + window.scrollY + yOffset;

    setTimeout(() => {
      window.scrollTo({
        top: yPosition,
        behavior: 'smooth',
      });
    }, 0);
  }
}
